import { useEffect, useRef } from 'react';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Types
import type { ErrorCustom } from '@/utils/client';
// Hooks
import useIntersectionObserver from '@/utils/hooks/utils/useIntersectionObserver';

// Libs
import { SIZE_FULL } from '@/lib/gridElements/size';

import InfoBanner from '@/components/base/InfoBanner';
// Components
import AnalyticsGrid from '@/components/layouts/wrappers/AnalyticsGrid';
import { Trans } from '@/components/tools/translation';

type AnalyticsErrorBannerType = {
    analyticsError: ErrorCustom;
    mutateAnalytics: () => void;
};

const AnalyticsErrorBanner = ({ analyticsError, mutateAnalytics }: AnalyticsErrorBannerType) => {
    const { t } = useTranslation('errors');
    const refBannerInfo = useRef<HTMLDivElement>(null);
    const bannerInfoInViewPort = useIntersectionObserver(refBannerInfo, { threshold: 0 });

    // scroll to error
    useEffect(() => {
        // Scroll To info banner if it's not visible in the viewport
        if (!bannerInfoInViewPort && analyticsError) {
            refBannerInfo?.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [bannerInfoInViewPort, analyticsError]);

    if (!analyticsError) {
        return null;
    }
    return (
        <AnalyticsGrid.Item size={SIZE_FULL} className="!min-h-0" ref={refBannerInfo}>
            <InfoBanner
                title={t('error_occured')}
                message={
                    <Trans
                        i18nKey="analytics:error_data_fetching"
                        components={{
                            tag0: (
                                <button
                                    key="error"
                                    className="text-icoRed underline"
                                    onClick={mutateAnalytics}
                                />
                            )
                        }}
                    />
                }
            />
        </AnalyticsGrid.Item>
    );
};

export default AnalyticsErrorBanner;
